export enum PhApprovalHierarchyStatusEnum{
    APPROVED='APPROVED',
    OPEN ='OPEN',
    REJECTED ='REJECTED',
}